<template>
  <el-dialog
    :title="curItem && curItem.id ? '编辑事项' : '添加事项'"
    :visible.sync="dialogVisible"
    width="680px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <el-form
        :model="formInline"
        ref="form"
        label-width="110px"
        :rules="rules"
      >
        <el-form-item label="事项名称" prop="sxmc">
          <el-input
            :disabled="!!formInline.id"
            v-model="formInline.sxmc"
            placeholder="事项名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="标准图片" style="margin-right:0;width:100%;">
          <el-upload
            class="avatar-uploader"
            :class="picFilesJson.length >= 5 ? 'limitMax' : ''"
            action="#"
            :on-remove="handleRemove"
            :file-list="picFilesJson"
            list-type="picture-card"
            accept="image/png,image/jpg,image/jpeg"
            :limit="5"
            :http-request="uploadPicFileFun"
          >
            <i style="font-size: 48px;" class="el-icon-upload" v-if="picFilesJson.length < 5"></i>
          </el-upload>
          <div class="tip">建议图片比例3:2，支持jpeg、jpg、png等图片格式，最多上传5张</div>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="editFun">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { eventEdit } from "@/api/base.js";
import { uploadFile } from "@/api/block.js";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    curItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      picFilesJson: [],
      userList: [],
      deptList: [],
      formInline: {
        sxmc: "",
        id: "",
      },
      rules: {
        sxmc: [{ required: true, message: "请输入事项名称", trigger: "blur" }],
      },
    };
  },
  mounted() {
    if (this.curItem && this.curItem.id) {
      this.formInline = JSON.parse(JSON.stringify(this.curItem));
      this.picFilesJson = this.formInline.ckImgJson ? JSON.parse(this.formInline.ckImgJson) : [];
    }
  },
  methods: {
    handleRemove(file) {
      this.picFilesJson.splice(this.picFilesJson.findIndex(item => item.id == file.id), 1);
    },
    uploadPicFileFun(file) {
      console.log(file)
      if (!file.file.name.endsWith(".jpeg") && !file.file.name.endsWith(".jpg") && !file.file.name.endsWith(".png")) {
        this.$message({
          message: "请上传正确格式文件，支持文件类型：.jpeg、.jpg、.png",
          type: "warning"
        });
        return;
      }
      if (this.picFilesJson && this.picFilesJson.length >= 5) return this.$message.error('最多上传5张照片');
      this.uploadFileFun(file, "gh_block_organization");
    },
    async uploadFileFun(file, type) {
      let formData = new FormData();
      formData.append("file", file.file);
      formData.append("objectName", type);
      const res = await uploadFile(formData);
      if (res.data.code === 200) {
        this.picFilesJson.push({
          ...res.data.data,
          name: res.data.data.fileName,
          url:
            process.env.VUE_APP_API_IMG_PATH + res.data.data.filePath,
          imageUrl: res.data.data.filePath
        });
      }
    },
    getDeptId() {
      try {
        const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        return userInfo.deptId;
      } catch (error) {
        console.error(error);
        return "";
      }
    },
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    },
    async editFun(submitFlag) {
      let xx = true;
      this.$refs["form"].validate(valid => {
        if (valid) {
          xx = true;
        } else {
          xx = false;
        }
      });
      if (xx == false) {
        this.$message({
          message: "请输入或选择必填项",
          type: "warning"
        });
        return false;
      }
      let params = {
        sxmc: this.formInline.sxmc,
        id: this.formInline.id,
        ckImgJson: JSON.stringify(this.picFilesJson),
        ghEventTypeId: "id_ai_audit",
        extendClient: "关芯客服"
      };
      // if (this.formInline.superFlag == "EVENT_TYPE_TYPE_FRC") {
      //   params.tjDeptId = this.formInline.tjDeptId || this.getDeptId();
      //   let adminUsers = [];
      //   if (this.formInline.adminUsers.length > 0) {
      //     adminUsers = this.userList.filter(item =>
      //       this.formInline.adminUsers.includes(item.userid)
      //     );
      //   }
      //   params.adminUsers = adminUsers;
      // }
      const res = await eventEdit(params);
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.handleClose();
        this.$emit("refreshList", {
          curItem: this.formInline
        });
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
  },
  computed: {}
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 24px;
}

/deep/.el-upload__input {
  display: none;
}
// /deep/.avatar-uploader {
//   display: flex;
// }
.el-upload__text {
  height: auto;
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 16px;
  color: #494c4f;
  display: inline-block;
  margin: 8px 0;
}
.tip {
  font-family: MiSans, MiSans;
  font-weight: 400;
  font-size: 14px;
  color: #92979c;
}
.limitMax {
  /deep/ .el-upload--picture-card {
    background: #fff !important;
    border: none !important;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/mCheckInManage/sxzbManage/components/typeDialog.vue